export default {
    reports_main_title: 'Reportes',
    reports_main_report: 'Reporte',
    reports_main_description: 'Descripción',
    reports_main_platform: 'Plataforma',
    reports_main_execute: 'Ejecutar',
    reports_main_status: "Estado",
    reports_main_created: "Creación",
    reports_main_updated: "Actualización",
    reports_export_history: "Historial de Exportaciones",
};